export function isRTL(str) {
    var _a, _b, _c;
    // Regular expression to match RTL characters
    const rtlRegex = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/;
    try {
        return (str &&
            rtlRegex.test(((_c = (_b = (_a = str === null || str === void 0 ? void 0 : str.replace(/\d+/g, '')) === null || _a === void 0 ? void 0 : _a.replace(/[.\):]/gi, '')) === null || _b === void 0 ? void 0 : _b.trim()) === null || _c === void 0 ? void 0 : _c.split(' ')[0]) || ''));
    }
    catch (e) {
        return false;
    }
}
export const OR = (a, b) => (a !== undefined ? a : b);
export function startsWithRTL(str) {
    const rtlRegex = /^[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/;
    try {
        if (!str)
            return false;
        const firstChar = str
            .trim()
            .replace(/^[^A-Za-z\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]+/, '');
        return rtlRegex.test(firstChar);
    }
    catch (e) {
        return false;
    }
}
